/** Default avatar color when user has not chosen one. */
export const DEFAULT_AVATAR_COLOR = '#7FB7E6';

/** Soft pastel palette for avatar color picker. */
export const AVATAR_COLOR_PALETTE = [
  '#F28FA8', '#E68EC0', '#CC94E0', '#B694E8',
  '#93A7E9', '#7FB7E6', '#78C8E6', '#82D9CB',
  '#88D8A0', '#B9D77A', '#E2DA7A', '#F3C97A',
  '#F5B58A', '#F2A37F', '#D7A6C2', '#BFAFCF',
];

export function getUserInitials(firstName, lastName, email) {
  const f = String(firstName || '').trim();
  const l = String(lastName || '').trim();
  if (f && l) return (f[0] + l[0]).toUpperCase();
  if (f.length >= 2) return f.slice(0, 2).toUpperCase();
  if (f) return f[0].toUpperCase();
  if (l.length >= 2) return l.slice(0, 2).toUpperCase();
  if (l) return l[0].toUpperCase();
  const e = String(email || '').trim();
  if (e) return e[0].toUpperCase();
  return '?';
}

export function resolveAvatarColor(avatarColor) {
  return typeof avatarColor === 'string' && /^#[0-9A-Fa-f]{6}$/.test(avatarColor)
    ? avatarColor
    : DEFAULT_AVATAR_COLOR;
}
